module.exports = __webpack_public_path__ + "img/video_bg2.3375bf53.jpg";